import { GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  menus: [],
  us: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  details: {},
};

const contactReducer = function (state = initialState, action) {
  switch (action.type) {
    case GLOBAL_CATALOGS.Contact.Root: {
      return {
        ...state,
        menus: action.payload
      };
    }
    case GLOBAL_CATALOGS.Contact.Us.List: {
      return {
        ...state,
        us: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default contactReducer;
